import React, { useState } from 'react';
import { ChevronDown } from "lucide-react";

const faqData = [
  {
    question: "When should I enroll in Medicare?",
    answer: "The window opens three months before your 65th birthday and closes three months after. That's a seven-month window — and it goes fast. If you miss it, you'll likely pay a higher premium every single month going forward with no end date on that penalty.",
  },
  {
    question: "I'm still on my employer's health plan. Do I still need to sign up?",
    answer: "Not necessarily right away — but you need to be careful. When your employer coverage ends, you have a limited Special Enrollment Period to switch to Medicare without facing a penalty. A lot of people assume they have more time than they do. Don't guess on this one.",
  },
  {
    question: "I'm already getting Social Security. Am I automatically enrolled?",
    answer: "Yes, in most cases. If you were receiving Social Security before turning 65, Medicare Parts A and B are typically set up for you automatically. You should still confirm your enrollment and make sure your plan actually covers what you need.",
  },
  {
    question: "What happens if I've already missed my window?",
    answer: "You can still enroll during the General Enrollment Period, which runs from January through March each year. But the late penalty will likely still apply and gets bigger the longer you've waited. The sooner you sort this out, the better.",
  },
  {
    question: "Does getting help cost me anything?",
    answer: "Nothing. The case review is completely free. There are no upfront fees and no obligation. We're here to help you understand your options — nothing more.",
  },
];

const HomeEight = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (idx) => {
    setActiveIndex(idx === activeIndex ? null : idx);
  };

  return (
    <section className="py-12 px-2 sm:px-4 md:px-8 lg:px-16 w-full max-w-none" style={{ fontFamily: 'Quicksand, sans-serif' }}>
      {/* Title */}
      <h2
        className="text-[32px] sm:text-[40px] font-semibold text-[#0A1F8F] mb-6 capitalize leading-none"
      >
        Frequently Asked{' '}
        <span className="text-[#EDC14A] font-semibold capitalize">
          Questions
        </span>
      </h2>

      {/* Accordion */}
      <div className="space-y-4">
        {faqData.map((item, idx) => (
          <div key={idx} className="border border-gray-200 rounded overflow-hidden">
            <button
              onClick={() => toggle(idx)}
              className={`w-full text-left px-4 py-3 flex justify-between items-center ${
                activeIndex === idx ? 'bg-[#F4F6FC]' : 'bg-white'
              } transition`}
              style={{ fontFamily: 'Quicksand, sans-serif' }}
            >
              <span className="text-[#0A1F8F] text-[20px] sm:text-[24px] font-semibold leading-normal">
                {item.question}
              </span>
             
              <span className="text-[18px] font-light select-none">
                <ChevronDown
                  className={`w-5 h-5 transform transition-transform duration-300 
                  ${activeIndex === idx ? "rotate-180 text-[#EDC14A]" : "text-[#0A1F8F]"}`}
                />
              </span>
            </button>
            {activeIndex === idx && (
              <div className="px-4 pb-4 pt-1 text-[#757575] text-[18px] sm:text-[20px] font-medium leading-normal bg-[#F4F6FC]" style={{ fontFamily: 'Quicksand, sans-serif' }}>
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeEight;